
import Fly from 'flyio/dist/npm/fly'
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

import {authRegister} from '@/api/user'


export default {
components: {
XInput,
Group,
XButton
},
data () {
return {
loginModel: {
mobile: '',
password: '',
comfirmpwd: '',
identity: 'advertiser',
captcha: '',
captcha_token: '',
captcha_sms: '',
scope: 'mobile_forgot'
},
captchaImg: '/static/images/vcode.jpg',
smsCount: 0,
smsDisable: false
}
},
methods: {

smsCountDown () {
const _this = this
_this.smsCount = 60
_this.smsDisable = true
let interval = window.setInterval(function () {
console.log(_this.smsCount)
--_this.smsCount
if (_this.smsCount === 0) {
_this.smsDisable = false
window.clearInterval(interval)
}
}, 1000)
},


register () {
let fly = new Fly() 
fly.request('https://api.ruan.net/api/auth/forgot_password', this.loginModel, {
method: 'post'
}).then(resp => {
if (resp.data.success) {



console.log('密码修改成功')
this.$router.replace('/login')
}
this.$vux.toast.show({
text: resp.data.message,
time: 1000
})
}).catch((e) => console.log('重置密码失败', e))
},
getTextCaptcha () {
if (!this.loginModel.captcha) {
this.$vux.toast.show({
text: '请输入正确的验证码',
time: 1000
})
this.getCaptcha()
}
if (!this.loginModel.mobile) {
this.$vux.toast.show({
text: '请输入手机号',
time: 1000
})
}
const textCaptchaModel = {
captcha: this.loginModel.captcha,
captcha_token: this.loginModel.captcha_token,
mobile: this.loginModel.mobile,
scope: 'mobile_forgot'
}
let fly = new Fly() 
fly.request('https://api.ruan.net/api/auth/captcha/sms', textCaptchaModel, {
method: 'post'
}).then(resp => {
if (!resp.data.success) {
this.getCaptcha()
} else {
this.smsCountDown()
}
this.$vux.toast.show({
text: resp.data.message,
time: 1000
})
}).catch((e) => console.log('获取短信验证码失败', e))
},
getCaptcha () {
let fly = new Fly() 
fly.config.withCredentials = true  
fly.request('https://api.ruan.net/api/auth/captcha/generate', {}, {
method: 'post'
}).then(resp => {
this.captchaImg = resp.data.data.src
this.loginModel.captcha_token = resp.data.data.captcha_token
}).catch((e) => console.log('error', e))
}

},
mounted () {
this.getCaptcha()
}
}



// WEBPACK FOOTER //
// ./src/pages/forgotPwd/index.vue